import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Webgenregame() {
  return (
    <section className="web_genre_game p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={7}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Web3 Game Genres For <span>Game Founders</span>
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="web_genre_img mb-3 mb-md-4">
              <StaticImage
                src="../../images/services-usa/web3-game/web_3_genre_1.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={510}
                height={323}
              />
              <div className="web_genre_head">
                <h5>Collectible card games</h5>
              </div>
            </div>
            <div className="web_genre_img mb-3 mb-md-0">
              <StaticImage
                src="../../images/services-usa/web3-game/web_3_genre_2.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={510}
                height={685}
              />
              <div className="web_genre_head">
                <h5>Sports and racing</h5>
              </div>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="web_genre_img mb-3 mb-md-4">
              <StaticImage
                src="../../images/services-usa/web3-game/web_3_genre_3.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={510}
                height={685}
              />
              <div className="web_genre_head">
                <h5>Cryptocurrency games</h5>
              </div>
            </div>
            <div className="web_genre_img mb-3 mb-md-0">
              <StaticImage
                src="../../images/services-usa/web3-game/web_3_genre_6.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={510}
                height={323}
              />
              <div className="web_genre_head">
                <h5>Real-world simulation</h5>
              </div>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="web_genre_img mb-3 mb-md-4">
              <StaticImage
                src="../../images/services-usa/web3-game/web_3_genre_4.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={510}
                height={323}
              />
              <div className="web_genre_head">
                <h5>Strategy and role-playing</h5>
              </div>
            </div>
            <div className="web_genre_img">
              <StaticImage
                src="../../images/services-usa/web3-game/web_3_genre_5.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={510}
                height={685}
              />
              <div className="web_genre_head">
                <h5>Sandbox</h5>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Webgenregame;
